<template>
  <div>
    <Header state="add" />
    <CoinHeading :name="coinData.name" :symbol="coinData.symbol" :iconUrl="coinData.iconUrl" />
    <form>
      <div class="form-group">
        <label class="form-label" for="form-amount">Amount</label>
        <input
          id="form-amount"
          class="form-input"
          type="number"
          min="0"
          step="0.00000000001"
          placeholder="e.g. 1000.01"
          v-model="userInputs.amount"
          @keyup="isFormValid">
      </div>
      <div class="form-group">
        <label class="form-label" for="form-purchase-currency">Purchase currency</label>
        <input
          id="form-purchase-currency"
          class="form-input"
          type="text"
          pattern=".{3,3}"
          placeholder="e.g.
          GBP"
          readonly
          value="GBP">
        <small>Note: only support GBP for now</small>
      </div>
      <!-- <div class="form-group">
        <label class="form-label" for="form-purchase-price">Purchase Price</label>
        <input class="form-input" type="number" min="0" step="0.01" id="form-purchase-price" placeholder="e.g. 100.50">
      </div> -->
      <div class="form-group">
        <label class="form-label" for="form-purchase-price">Purchase price</label>
        <input
          id="form-purchase-price"
          class="form-input"
          type="number"
          min="0"
          step="0.01"
          placeholder="e.g. 100.50"
          v-model="userInputs.purchasePrice"
          @keyup="isFormValid">
      </div>
      <div class="button-wrapper">
        <button class="btn btn-primary" @click="addCoin" :disabled="!validForm">
          <i class="fa fa-plus"></i> Add
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Router from '@/router';
import Service from '@/service';
import Header from '@/components/header/Header';
import CoinHeading from '@/components/coin/CoinHeading';

export default {
  name: 'AddExistingCoin',
  components: {
    Header,
    CoinHeading,
  },
  data() {
    return {
      coinId: this.$route.params.coinId,
      coinData: {},
      userInputs: {},
      validForm: false,
    };
  },
  mounted() {
    this.getCoinData();
  },
  methods: {
    getCoinData() {
      if (this.coinId) {
        let result = {};
        Service.getCoinsByIds(this.coinId).then((response) => {
          if (response && response.status === 'success') {
            if (response.data && response.data.coins && response.data.coins.length === 1) {
              result = response.data.coins[0];
            }
          }
          this.coinData = result;
        });
      }
    },
    addCoin() {
      if (this.validForm) {
        const coin = {
          id: this.coinData.id,
          code: this.coinData.symbol,
          amount: this.userInputs.amount,
          purchasePrice: this.userInputs.purchasePrice,
          purchaseCurrency: 'GBP',
        };

        Service.addPurchase(coin);
        Router.push({ name: 'Account' });
      }
    },
    isFormValid() {
      const hasCoinData = this.coinData && this.coinData.id && this.coinData.symbol;
      const hasUserData = this.userInputs && this.userInputs.amount && this.userInputs.purchasePrice;
      if (hasCoinData && hasUserData) {
        this.validForm = true;
      } else {
        this.validForm = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
form {
  padding: 0 1rem 1rem 1rem;

  .button-wrapper {
    text-align: center;

    button {
      padding: 0 1.5rem;
      margin-top: 0.5rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/view/AddExistingCoin.vue